import React from "react";
import OriginalAsyncSelect, { AsyncSelectControlProps } from "@edaz/edazkit/controls/AsyncSelect";
import { setVisitedProperty } from "../utils/validationPatch";
import { PropertyName } from "@frui.ts/helpers";
import { IBindingProps } from "@frui.ts/views";
import { CommonInputProps } from "@frui.ts/bootstrap/dist/controls/commonInputProps";

export default function AsyncSelect<TTarget, IsMulti extends boolean = false>(
  props: Omit<AsyncSelectControlProps<IsMulti>, "onChange" | "value"> & IBindingProps<TTarget> & CommonInputProps
) {
  const { onBlur, ...rest } = props;
  const { target, property } = props as { target: TTarget; property: PropertyName<TTarget> };
  const modifiedOnBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (onBlur) {
      onBlur(e);
    }

    setVisitedProperty(target, property);
  };

  return <OriginalAsyncSelect onBlur={modifiedOnBlur} {...rest} />;
}
